/* eslint-disable react/style-prop-object */
import { Box } from "@mui/material";
import React from "react";

function Loader() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        boxSizing:"border-box"
      }}
    >
      <dotlottie-player
        src="https://lottie.host/02e73b38-e529-473b-acd8-1518fa98a763/ZnXkNKPO3Z.json"
        background="transparent"
        speed="1"
        style={{ width: "300px", height: "300px" }}
        loop
        autoplay
      ></dotlottie-player>
    </Box>
  );
}

export default Loader;
